import type { BridgeMessageHandler } from '../message-router.js';

export const handleRenameSessionBranchMessage: BridgeMessageHandler<'rename_session_branch'> = (msg, deps) => {
  const sessionId = typeof msg.sessionId === 'string' ? msg.sessionId : '';
  const newBranch = typeof msg.newBranch === 'string' ? msg.newBranch : '';
  if (!sessionId || !newBranch) return;
  void deps.sessionWorktreeManager.renameSessionBranch(sessionId, newBranch);
};
